import { PLAN_TYPE, PlanType } from "@/constants";

import DataDisplay, { DataDisplayComponent } from "./DataDisplay";

const PlanDisplay: DataDisplayComponent<PlanType> = (props) => {
  const PLAN_MAP = {
    [PLAN_TYPE.FREE]: L.FREE_PLAN_NAME,
    [PLAN_TYPE.BASIC]: L.BASIC_PLAN_NAME,
    [PLAN_TYPE.CUSTOM]: L.CUSTOM_PLAN_NAME,
    [PLAN_TYPE.US_FREE]: L.GROWTH_FREE_PLAN_NAME,
    [PLAN_TYPE.US_BASIC]: L.GROWTH_BASIC_PLAN_NAME,
  };

  return <DataDisplay dictionary={PLAN_MAP} {...props} />;
};

export default PlanDisplay;
